import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import styles from './productpage.module.css'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import authservice from '../Authentication/service/authservice';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import Modal from "react-modal";
import { Button } from 'react-bootstrap';
import mart from '../../assets/mart.png';
import TextDecoration from '../utility/TextDecoration';
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import sty from '../listings/forms/addpost.module.css';
import stylesCard from '../listings/cards/card.module.css'
import { useViewport } from '../utility/useViewport';

const ProductPage = (props) => {
  const { id } = useParams();
  const { martname } = useParams();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});
  const [currentIndex, setCurrentIndex] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [martDetails, setMartDetails] = useState(null);
  const [martStatus, setMartStatus] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [cartItems, setCartItems] = useState([]);

  const [showCartModal, setShowCartModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [cartMartId, setCartMartId] = useState(localStorage.getItem("cartMartId"));
  const [cartClearing, setCartClearing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const shareLinkRef = useRef(null);
  const [showInfoPopup, setShowInfoPopup] = useState({});
  const [selectedSizes, setSelectedSizes] = useState({});

  const handleSizeChange = (productId, selectedSizeObj) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: selectedSizeObj,
    }));
  };


  const toggleInfoPopup = (productId) => {
    setShowInfoPopup((prev) => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const showShareDialog = () => setIsDialogOpen(true);
  const hideShareDialog = () => setIsDialogOpen(false);

  const copyToClipboard = () => {
    if (shareLinkRef.current) {
      shareLinkRef.current.select();
      document.execCommand('copy');
    }
  };

  const shareTo = (platform) => {
    const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
    const baseUrl = `${window.location.origin}/mart/${businessName}/${id}/products}`;
    let url = '';

    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`;
        break;
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(baseUrl)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'skype':
        url = `https://web.skype.com/share?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'snapchat':
        // Snapchat doesn’t support direct link sharing via URL; consider custom integration
        alert("Snapchat sharing not supported directly.");
        return;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(baseUrl)}`;
        break;
      case 'gmail':
        url = `mailto:?subject=Check this out&body=${encodeURIComponent(baseUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  const businessName = martname.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')

  const shareUrl = `${window.location.origin}/mart/${businessName}/${id}/products`;

  const fetchMartDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartDetails(response.data);
      setModalIsOpen(true);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  const fetchMartStatusDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-mart/${id}`
      );
      setMartStatus(response.data.open);
    } catch (error) {
      console.error("Error fetching mart details:", error);
    }
  };

  useEffect(() => {
    const initialIndex = {};
    products.forEach((product) => {
      initialIndex[`${product.id}_${product.size}`] = 0;
    });
    setCurrentIndex(initialIndex);
  }, [products]);

  // const handleNext = (productId, totalImages) => {
  //   setCurrentIndex((prev) => ({
  //     ...prev,
  //     [productId]: (prev[productId] + 1) % totalImages,
  //   }));
  // };

  // const handlePrev = (productId, totalImages) => {
  //   setCurrentIndex((prev) => ({
  //     ...prev,
  //     [productId]: (prev[productId] - 1 + totalImages) % totalImages,
  //   }));
  // };

  const handleNext = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] + 1) % totalImages,
      };
    });
  };


  const handlePrev = (productId, size, totalImages) => {
    setCurrentIndex((prev) => {
      const key = `${productId}_${size}`;
      return {
        ...prev,
        [key]: (prev[key] - 1 + totalImages) % totalImages,
      };
    });
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prev) => {
  //       const newIndexes = { ...prev };
  //       products.forEach((product) => {
  //         const totalImages = product.productImages.length;
  //         if (totalImages > 1) {
  //           newIndexes[product.id] = (prev[product.id] + 1) % totalImages;
  //         }
  //       });
  //       return newIndexes;
  //     });
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [products]);

  const handleClearCart = async () => {
    setShowCartModal(false);
    setCartClearing(true);
    setPendingProduct(null);

    const userId = authservice.getCurrentUserid();

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}?paymentMode=PHONEPE`
      );

      if (response.data && response.data.items.length > 0) {
        await Promise.all(
          response.data.items.map(item =>
            axios.delete(
              `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/clear-shopping-bag/${userId}`
            )
          )
        );
      }

      localStorage.removeItem("cart");
      localStorage.setItem("cartMartId", id);
      setCart({});
      setCartMartId(id);

      setTimeout(() => {
        setCartClearing(false);
        if (pendingProduct) {
          //addToCart(pendingProduct.product);
          setPendingProduct(null);
        }
      }, 300);
    } catch (error) {
      console.error("❌ Error clearing cart:", error);
      setCartClearing(false);
    }
  };

  const selectedProducts = useMemo(() => {
    return selectedCategory ? products.filter(p => p.productCategory === selectedCategory) : products;
  }, [selectedCategory, products]);

  // const remainingProducts = useMemo(() => {
  //   return selectedCategory ? products.filter(p => p.productCategory !== selectedCategory) : products;
  // }, [products]);

  // const remainingProducts = products.reduce((acc, product) => {
  //   if (!acc[product.productId]) {
  //     acc[product.productId] = {
  //       ...product,
  //       sizes: [],
  //     };
  //   }
  //   acc[product.productId].sizes.push({
  //     size: product.size,
  //     price: product.price,
  //     stock: product.stock,
  //   });
  //   return acc;
  // }, {});

  // const remainingProductsList = Object.values(remainingProducts);


  useEffect(() => {
    fetchMartStatusDetails()
    fetchProducts();
    if (authservice.getCurrentUserid() !== null)
      fetchCart()
    window.scroll(0, 0)
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/get-published-products/${id}`);
      const formattedProducts = response.data.flatMap(product =>
        product.sizeStockPrices.map(sizeData => ({
          ...product,
          size: sizeData.size,
          price: sizeData.productPrice, // Corrected price property
          remainingStock: sizeData.stockQuantity, // Corrected stock property
          productImage: product.productImages[0] || "default-image.jpg"
        }))
      );
      setProducts(formattedProducts);
      const uniqueCategories = [...new Set(response.data.map(p => p.productCategory))];
      setCategories(uniqueCategories);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchCart = async () => {
    const userId = authservice.getCurrentUserid();
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}?paymentMode=PHONEPE`);
      setCartItems(response.data.items || []);
      const cartData = {};

      response.data.items.forEach((item) => {
        //const productKey = `${item.size}-${item.productId}`;
        cartData[item.size + item.productId] = item.quantity;
      });
      setCart(cartData);
      localStorage.setItem("cart", JSON.stringify(cartData)); // Sync local storage
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  // const handleAddToCart = async (product) => {
  //   if (showCartModal) return;
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   const quantity = 1;
  //   if (authservice.getCurrentUserid() === null)
  //     setShowLoginModal(true)
  //   else {
  //     if (cartMartId && cartMartId !== currentMartId) {
  //       setPendingProduct({ product, size: product.size, quantity });
  //       setShowCartModal(true);
  //       return;
  //     }
  //   }
  //   axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //     null,
  //     {
  //       params: { productId: product.id, size: product.size, quantity, paymentMode: "PHONEPE" },
  //     }).then(() => {
  //       setCart((prevCart) => {
  //         const updatedCart = { ...prevCart, [product.size + product.id]: quantity }
  //         localStorage.setItem("cart", JSON.stringify(updatedCart));
  //         localStorage.setItem("cartMartId", currentMartId);
  //         setCartMartId(currentMartId);
  //         return updatedCart;
  //       });

  //       fetchCart();
  //     }).catch((error) => console.error("Error adding to cart:", error))
  // };


  const handleAddToCart = async (product, selectedSizeObj) => {
    if (showCartModal) return;

    const userId = authservice.getCurrentUserid();
    const currentMartId = id;
    const quantity = 1;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (cartMartId && cartMartId !== currentMartId) {
      // Cart conflict - from different mart
      setPendingProduct({ product, size, quantity });
      setShowCartModal(true);
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity,
            paymentMode: "PHONEPE",
          },
        }
      );

      // Update cart in state and localStorage
      setCart((prevCart) => {
        const existingQty = prevCart[cartKey] || 0;
        const updatedCart = {
          ...prevCart,
          [cartKey]: existingQty + 1,
        };
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        localStorage.setItem("cartMartId", currentMartId);
        setCartMartId(currentMartId);
        return updatedCart;
      });

      fetchCart(); // refresh cart from backend
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };


  // const handleIncreaseQuantity = async (product) => {
  //   console.log("Product object:", product);
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   if (!product.id || !product.size) {
  //     console.error("Error: productId or size is missing!", product);
  //     return;
  //   }

  //   setCart((prevCart) => {
  //     const currentQuantity = prevCart[product.size + product.id] || 0;
  //     const newQuantity = currentQuantity + 1;

  //     const updatedCart = { ...prevCart, [product.size + product.id]: newQuantity };
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //     localStorage.setItem("cartMartId", currentMartId);
  //     setCartMartId(currentMartId);

  //     return updatedCart;
  //   });

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //       null, // No body, only params
  //       {
  //         params: {
  //           productId: product.id,
  //           size: product.size,
  //           quantity: cart[product.size + product.id] + 1 || 1, // Ensure correct quantity
  //           paymentMode: "PHONEPE"
  //         },
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     // fetchCart(); // Refresh cart after successful API request
  //   } catch (error) {
  //     console.error("Error increasing quantity:", error);
  //   }
  // };

  const handleIncreaseQuantity = async (product, selectedSizeObj) => {
    const userId = authservice.getCurrentUserid();
    const currentMartId = id;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (!size || !product.id) {
      console.error("Error: productId or size is missing!", { size, productId: product.id });
      return;
    }

    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ product, size, quantity: 1 });
      setShowCartModal(true);
      return;
    }

    const currentQuantity = cart[cartKey] || 0;
    const newQuantity = currentQuantity + 1;

    setCart((prevCart) => {
      const updatedCart = {
        ...prevCart,
        [cartKey]: newQuantity,
      };
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      localStorage.setItem("cartMartId", currentMartId);
      setCartMartId(currentMartId);
      return updatedCart;
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity: newQuantity,
            paymentMode: "PHONEPE",
          },
          headers: { "Content-Type": "application/json" },
        }
      );
      // fetchCart(); // Optional if needed
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };


  // const handleDecresaeQuantity = async (product) => {
  //   console.log("Product object:", product);
  //   const userId = authservice.getCurrentUserid();
  //   const currentMartId = id;

  //   if (!product.id || !product.size) {
  //     console.error("Error: productId or size is missing!", product);
  //     return;
  //   }

  //   setCart((prevCart) => {
  //     const currentQuantity = prevCart[product.size + product.id] || 0;
  //     const newQuantity = currentQuantity - 1;

  //     const updatedCart = { ...prevCart, [product.size + product.id]: newQuantity };
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //     localStorage.setItem("cartMartId", currentMartId);
  //     setCartMartId(currentMartId);

  //     return updatedCart;
  //   });

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
  //       null, // No body, only params
  //       {
  //         params: {
  //           productId: product.id,
  //           size: product.size,
  //           quantity: cart[product.size + product.id] - 1 || 0,
  //           paymentMode: "PHONEPE"
  //         },
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error increasing quantity:", error);
  //   }
  // };

  const handleDecresaeQuantity = async (product, selectedSizeObj) => {
    const userId = authservice.getCurrentUserid();
    const currentMartId = id;

    if (!userId) {
      setShowLoginModal(true);
      return;
    }

    const size = selectedSizeObj.size;
    const cartKey = size + product.id;

    if (!size || !product.id) {
      console.error("Error: productId or size is missing!", { size, productId: product.id });
      return;
    }

    if (cartMartId && cartMartId !== currentMartId) {
      setPendingProduct({ product, size, quantity: 1 });
      setShowCartModal(true);
      return;
    }

    const currentQuantity = cart[cartKey] || 0;
    const newQuantity = Math.max(currentQuantity - 1, 0); // prevent negative quantity

    // If quantity is 0, remove it from cart
    setCart((prevCart) => {
      const updatedCart = { ...prevCart };
      if (newQuantity === 0) {
        delete updatedCart[cartKey];
      } else {
        updatedCart[cartKey] = newQuantity;
      }

      localStorage.setItem("cart", JSON.stringify(updatedCart));
      localStorage.setItem("cartMartId", currentMartId);
      setCartMartId(currentMartId);

      return updatedCart;
    });

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/shopping-bag/${userId}/products`,
        null,
        {
          params: {
            productId: product.id,
            size,
            quantity: newQuantity,
            paymentMode: "PHONEPE",
          },
          headers: { "Content-Type": "application/json" },
        }
      );
    } catch (error) {
      console.error("Error decreasing quantity:", error);
    }
  };


  const redirect = (url) => {
    if (url) {
      const fixedUrl = url.startsWith("http://") || url.startsWith("https://")
        ? url
        : `https://${url}`;
      window.open(fixedUrl, "_blank");
    }
  };

  // const uniqueProducts = Array.from(
  //   new Map(remainingProducts.map((p) => [p.id, p])).values()
  // );

  const uniqueProductsSelected = Array.from(
    new Map(selectedProducts.map((p) => [p.id, p])).values()
  );


  return (
    <div className={styles.admin_view_head}>
      <div className={`col-md-2 add_button animated_back_button text-right d-none d-md-block ${styles.bckBtn}`}>
        <ButtonStyle type="button" className="form-control btn btn-block btn_font"
          handleClick={() => props.history.push("/mart")}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
      </div>
      {martStatus === false ? (
        <div className={styles.martClosedContainer}>
          <img
            src={mart} // Replace with actual path
            alt="Mart Closed"
            className={styles.martClosedGif}
          />
        </div>
      ) : (
        <>
          <Modal isOpen={showCartModal} onRequestClose={() => setShowCartModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Clear Cart?</h3>
              <p><strong>You already have products from a different mart. Do you want to clear your cart and add this product?</strong></p>
              <div className={styles.modalButtons}>
                <Button variant="danger" className="secondary" onClick={handleClearCart} disabled={cartClearing}>
                  {cartClearing ? "Clearing..." : "Yes, Clear Cart"}
                </Button>&nbsp;
                <Button className="secondary" variant="secondary" onClick={() => setShowCartModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <Modal isOpen={showLoginModal} onRequestClose={() => showLoginModal(false)}
            className={styles.modalContent} overlayClassName={styles.modalOverlay}>
            <div className={styles.martDetails}>
              <h3 className={styles.product_name}>Add To Cart?</h3>
              <p><strong>To add this product in the cart, you have to <Link to="/registration">register</Link> or <Link to="/login/user">login</Link>  your account.</strong></p>
              <div className={styles.modalButtons}>
                <Button className="secondary" variant="secondary" onClick={() => setShowLoginModal(false)}>No</Button>
              </div>
            </div>
          </Modal>
          <div className={`col-md-3 ${styles.cartButtonContainer} d-none d-md-flex m-5`}>
            {/* <ButtonStyle type="button" className="form-control btn btn-block btn_font"> */}
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} to="/mart/product/cart">🛒 Go to Cart</Link>
            {/* </ButtonStyle> */}
            <span className={styles.infoIcon} onClick={fetchMartDetails}>
              i
            </span>
            <Link style={{ color: "#fff", backgroundColor: '#FF9933' }} type="button" className={`form-control btn btn-block ${styles.btn_font_share}`} onClick={showShareDialog}>
              Share
            </Link>
          </div>
          <div className={`row d-md-none ${styles.headerIcons}`}>
            <div className={`col-md-3 ${styles.leftIcon}`} style={{ width: '20%' }}>
              <button style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.backIcon}`}
                handleClick={() => props.history.push("/mart")}>Back </button>
            </div>&nbsp;
            <div className="col-md-6" style={{ width: '75%' }}>
              <div className={`row ${styles.rightIcon}`}>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link type="button" className={`btn btn-block ${styles.btn_font_cart_mob}`} to="/mart/product/cart">🛒</Link>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <div className={styles.infoIcon} onClick={fetchMartDetails}>i</div>
                </div>
                <div className={`col-md-3 ${styles.cartIcon}`}>
                  <Link style={{ color: '#fff' }} type="button" className={`btn btn-block ${styles.btn_font_share_mob}`} onClick={showShareDialog}><i class="fa fa-share-alt"></i></Link>
                </div>
              </div>
            </div>
          </div>
          {isDialogOpen && (
            <div className="sharedialog">
              <h2>Share this Clip</h2>
              <input
                type="text"
                value={shareUrl}
                ref={shareLinkRef}
                style={{ width: '80%', padding: '5px', marginBottom: '10px' }}
                readOnly
              />
              <button className="copylink" onClick={copyToClipboard}>
                <i className="fa fa-copy"></i>
              </button>
              <div className="sharebuttons">
                <div className="sharebutton fb" onClick={() => shareTo('facebook')}></div>
                <div className="sharebutton whatsapp" onClick={() => shareTo('whatsapp')}></div>
                <div className="sharebutton twitter" onClick={() => shareTo('twitter')}></div>
                <div className="sharebutton skype" onClick={() => shareTo('skype')}></div>
                <div className="sharebutton telegram" onClick={() => shareTo('telegram')}></div>
                <div className="sharebutton snapchat" onClick={() => shareTo('snapchat')}></div>
                <div className="sharebutton linkedin" onClick={() => shareTo('linkedin')}></div>
                <div className="sharebutton gmail" onClick={() => shareTo('gmail')}></div>
              </div>
              <button className="shareclose" onClick={hideShareDialog}>
                Close
              </button>
            </div>
          )}
          <div className={`row ${styles.filterContainer}`}>
            <label className={styles.filterLabel}>Select Category: &nbsp;
              <span className={styles.dropdown} onClick={() => setDropdownOpen(!dropdownOpen)}>
                <span className={styles.dropdownSelected}>
                  {selectedCategory || "All Categories"}
                </span>
                {dropdownOpen && (
                  <ul className={styles.dropdownList}>
                    <li
                      className={styles.dropdownItem}
                      onClick={() => { setSelectedCategory(""); setDropdownOpen(false); }}
                    >
                      All
                    </li>
                    {categories.map((category, index) => (
                      <li
                        key={index}
                        className={`${styles.dropdownItem} ${selectedCategory === category ? styles.active : ""}`}
                        onClick={() => { setSelectedCategory(category); setDropdownOpen(false); }}
                      >
                        {category}
                      </li>
                    ))}
                  </ul>
                )}
              </span>
            </label>
          </div>


          {selectedProducts.length > 0 && (
            <>
              <h3 className={styles.subheading}>Products</h3>
              <div className="row">
                {uniqueProductsSelected.map((product) => {
                  const cartItem = cartItems.find((item) => item.productId === product.productId && item.size === product.size);
                  if (!product.sizeStockPrices || product.sizeStockPrices.length === 0)
                    return null;
                  const selected =
                    selectedSizes[product.id] || product.sizeStockPrices[0];
                  const size = selected && selected.size ? selected.size : '';
                  const cartKey = size + product.id;
                  return (
                    <div key={product.productId} className={`col-6 col-sm-4 col-lg-3 col-xl-2 col-xxl-2 ${styles.low_padding}`}>
                      <div className={styles.listing_card_video}>
                        <div className={styles.carousel_container}>
                          {product.productImages.length > 1 && (
                            <>
                              <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                              </a>
                              <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                              </a>
                            </>
                          )}
                          <div className={styles.listing_thumb_image_video}>
                            <img
                              src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                              alt="Product"
                              className={styles.product_img}
                            />
                          </div>
                        </div>
                        <div className={styles.listing_details}>
                          <h3 className={styles.product_name}>{product.productName}</h3>
                          <div className={styles.listing_address}>
                            <p><span className={`d-md-block d-none ${styles.stock}`}>Size: &nbsp;
                              <select
                                value={selected.size}
                                onChange={(e) => {
                                  const selectedObj = product.sizeStockPrices.find(
                                    (s) => s.size === e.target.value
                                  );
                                  handleSizeChange(product.id, selectedObj);
                                }}
                              >
                                {product.sizeStockPrices.map((s) => (
                                  <option key={s.size} value={s.size}>
                                    {s.size}
                                  </option>
                                ))}
                              </select><br></br>
                              <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                              Stock: {product.remainingStock}</span>
                              <span className={styles.website} onClick={() => toggleInfoPopup(product.id)}>Product Description</span><br></br>
                            </p>
                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <button className={styles.info_btn} onClick={() => toggleInfoPopup(product.id)}>
                                  i
                                </button>
                              </div>
                              {cart[cartKey] ? (
                                <div className={styles.quantity_container}>
                                  <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>
                                    -
                                  </button>
                                  <span className={styles.quantity}>{cart[cartKey]}</span>
                                  <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>
                                    +
                                  </button>
                                </div>
                              ) : (
                                <div className={styles.quantity_container}>
                                  <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                                    Add to Cart
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                      </div>
                      {showInfoPopup[product.id] && (
                        <div className={styles.popup_overlay}>
                          <div className={styles.popup}>
                            <button className={styles.close_popup} onClick={() => toggleInfoPopup(product.id)}>X</button>
                            <div className={`${styles.carousel_container}`}>
                              {product.productImages.length > 1 && (
                                <>
                                  <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                                  </a>
                                  <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                    <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                                  </a>
                                </>
                              )}
                              <div className={styles.listing_thumb_image_video}>
                                <img
                                  src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                                  alt="Product"
                                  className={styles.popup_image}
                                />
                              </div>
                            </div>
                            <h3>{product.productName}</h3>
                            <p>{product.productDescription}</p>
                            <p className={styles.stockPopup}>Size: &nbsp;
                              <select
                                value={selected.size}
                                onChange={(e) => {
                                  const selectedObj = product.sizeStockPrices.find(
                                    (s) => s.size === e.target.value
                                  );
                                  handleSizeChange(product.id, selectedObj);
                                }}
                              >
                                {product.sizeStockPrices.map((s) => (
                                  <option key={s.size} value={s.size}>
                                    {s.size}
                                  </option>
                                ))}
                              </select><br></br>
                              <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                              Stock: {product.remainingStock}<br></br>
                              <span className={styles.website} onClick={() => redirect(product.webSite)}>{product.webSite ? <b>More Info</b> : null}</span>
                            </p>
                            <div className="d-flex justify-content-center">
                              <div className={styles.quantity_container}>
                                <button className={styles.add_to_cart} onClick={() => toggleInfoPopup(product.id)}>
                                  Close
                                </button>
                              </div> &nbsp;
                              {cart[cartKey] ? (
                                <div className={styles.quantity_container}>
                                  <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                                  <span className={styles.quantity}>{cart[cartKey]}</span>
                                  <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                                </div>
                              ) : (
                                <div className={styles.quantity_container}>
                                  <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>Add to Cart</button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>)
                })}
              </div>
            </>
          )}

          {/* <h3 className={styles.subheading}>All Products</h3>
          <div className="row">
            {uniqueProducts.map((product) => {
              const cartItem = cartItems.find((item) => item.productId === product.productId && item.size === product.size);
              if (!product.sizeStockPrices || product.sizeStockPrices.length === 0)
                return null;
              const selected =
                selectedSizes[product.id] || product.sizeStockPrices[0];
              const size = selected && selected.size ? selected.size : '';
              const cartKey = size + product.id;

              return (
                <div key={product.productId} className={`col-6 col-sm-4 col-lg-3 col-xl-2 col-xxl-2 ${styles.low_padding}`}>
                  <div className={styles.listing_card_video}>
                    <div className={`${styles.carousel_container}`}>
                      {product.productImages.length > 1 && (
                        <>
                          <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                            <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                          </a>
                          <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                            <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                          </a>
                        </>
                      )}
                      <div className={styles.listing_thumb_image_video}>
                        <img
                          src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                          alt="Product"
                          className={styles.product_img}
                        />
                      </div>
                    </div>
                    <div className={styles.listing_details}>
                      <h3 className={styles.product_name}>{product.productName}</h3>
                      <div className={` ${styles.listing_address}`}>
                        <p><span className={`d-md-block d-none ${styles.stock}`}>Size: &nbsp;
                          <select
                            value={selected.size}
                            onChange={(e) => {
                              const selectedObj = product.sizeStockPrices.find(
                                (s) => s.size === e.target.value
                              );
                              handleSizeChange(product.id, selectedObj);
                            }}
                          >
                            {product.sizeStockPrices.map((s) => (
                              <option key={s.size} value={s.size}>
                                {s.size}
                              </option>
                            ))}
                          </select><br></br>
                          <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                          Stock: {product.remainingStock}</span>
                          <span className={styles.website} onClick={() => toggleInfoPopup(product.id)}>Product Description</span><br></br>
                        </p>

                        <div className="d-flex justify-content-center">
                          {cart[cartKey] ? (
                            <div className={styles.quantity_container}>
                              <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>
                                -
                              </button>
                              <span className={styles.quantity}>{cart[cartKey]}</span>
                              <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>
                                +
                              </button>
                            </div>
                          ) : (
                            // <div className={styles.quantity_container}>
                            <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>
                              Add to Cart
                            </button>
                            // </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {showInfoPopup[product.id] && (
                    <div className={styles.popup_overlay}>
                      <div className={styles.popup}>
                        <button className={styles.close_popup} onClick={() => toggleInfoPopup(product.id)}>X</button>
                        <div className={`${styles.carousel_container}`}>
                          {product.productImages.length > 1 && (
                            <>
                              <a className={styles.prev_btn} onClick={() => handlePrev(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.previous_round}>&#8249;</a>
                              </a>
                              <a className={styles.next_btn} onClick={() => handleNext(product.id, product.size, product.productImages.length)}>
                                <a onClick={(e) => { e.preventDefault() }} className={styles.next_round}>&#8250;</a>
                              </a>
                            </>
                          )}
                          <div className={styles.listing_thumb_image_video}>
                            <img
                              src={`${process.env.REACT_APP_IMAGES_URL}${product.productImages[currentIndex[`${product.id}_${product.size}`] || 0]}`}
                              alt="Product"
                              className={styles.popup_image}
                            />
                          </div>
                        </div>
                        <h3>{product.productName}</h3>
                        <p>{product.productDescription}</p>
                        <p className={styles.stockPopup}>Size: &nbsp;
                          <select
                            value={selected.size}
                            onChange={(e) => {
                              const selectedObj = product.sizeStockPrices.find(
                                (s) => s.size === e.target.value
                              );
                              handleSizeChange(product.id, selectedObj);
                            }}
                          >
                            {product.sizeStockPrices.map((s) => (
                              <option key={s.size} value={s.size}>
                                {s.size}
                              </option>
                            ))}
                          </select><br></br>
                          <span className={styles.price}>Price: ₹{selected.productPrice}</span><br></br>
                          Stock: {product.remainingStock}<br></br>
                          <span className={styles.website} onClick={() => redirect(product.webSite)}>{product.webSite ? <b>More Info</b> : null}</span>
                        </p>
                        <div className="d-flex justify-content-center">
                          <div className={styles.quantity_container}>
                            <button className={styles.add_to_cart} onClick={() => toggleInfoPopup(product.id)}>
                              Close
                            </button>
                          </div> &nbsp;
                          {cart[cartKey] ? (
                            <div className={styles.quantity_container}>
                              <button className={styles.quantity_btn} onClick={() => handleDecresaeQuantity(product, selected)}>-</button>
                              <span className={styles.quantity}>{cart[cartKey]}</span>
                              <button className={styles.quantity_btn} onClick={() => handleIncreaseQuantity(product, selected)}>+</button>
                            </div>
                          ) : (
                            <div className={styles.quantity_container}>
                              <button className={styles.add_to_cart} onClick={() => handleAddToCart(product, selected)}>Add to Cart</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              )
            })}
          </div> */}

          {/* </div> */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            className={styles.modalContent}
            overlayClassName={styles.modalOverlay}
          >
            <Button variant="danger" className="popup-close-btn" onClick={() => setModalIsOpen(false)}>
              &times;
            </Button>
            {martDetails && (
              <div className={styles.martDetails}>
                <img
                  src={`${process.env.REACT_APP_IMAGES_URL}${martDetails.thumbnailImage}`}
                  alt="Mart Thumbnail"
                  className={styles.martImage}
                />
                <h2 className={styles.product_name}>{martDetails.martName}</h2>
                <p>{martDetails.businessDescription}</p>
                <p><strong>Address:</strong> {martDetails.businessAddress}</p>
                <p><strong>Contact Person:</strong> {martDetails.contactName}</p>
                <p><strong>Contact Number:</strong> {martDetails.contactNumber}</p>
                {/* <p><strong>Home Delivery: </strong> {martDetails.homeDeliveryAvailable ? 'Yes' : 'No'} </p>
                <p><strong>Pickup Available: </strong> {martDetails.pickupAvailable ? 'Yes' : 'No'} </p> */}
                <p><strong>Mart Open: </strong> {martDetails.open ? 'Yes' : 'No'} </p>
                <Button className="secondary" variant="secondary" onClick={() => setModalIsOpen(false)}>
                  Cancel
                </Button>
              </div>
            )}
          </Modal>
        </>
      )}<br></br>
      <div className={`listings row ${sty.large_rect}`}>
        {!props.isAdmin && <LargeRectangle spot={"-1"} />}
      </div>
      <div className={`${sty.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
        {!props.isAdmin && <BillBoard spot={"-1"} />}
      </div>
    </div >
  );
};

export default ProductPage;
